import React from 'react';

/**
 * Studio mark — Fibonacci squares tiling with golden spiral overlay.
 *
 * Props:
 *   size       — px (default 24)
 *   spiral     — show the golden-spiral arc overlay (default true)
 *   className  — extra Tailwind/CSS classes
 *   gradientId — override the gradient id if multiple icons render on one page
 */
const BonacciStudioIcon = ({ size = 24, spiral = true, className = '', gradientId = 'bonacci-studio-grad' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 48 48"
    width={size}
    height={size}
    fill="none"
    className={className}
    aria-hidden="true"
  >
    <defs>
      <linearGradient id={gradientId} x1="4" y1="11.5" x2="44" y2="36.5" gradientUnits="userSpaceOnUse">
        <stop offset="0" stopColor="#60a5fa" />
        <stop offset="0.55" stopColor="#a78bfa" />
        <stop offset="1" stopColor="#7c3aed" />
      </linearGradient>
    </defs>

    {/* A: 5×5 unit — largest, right */}
    <rect x="19" y="11.5" width="25" height="25" rx="3" fill={`url(#${gradientId})`} opacity="0.95" />
    {/* B: 3×3 unit — top-left */}
    <rect x="4" y="11.5" width="15" height="15" rx="2.2" fill={`url(#${gradientId})`} opacity="0.85" />
    {/* C: 2×2 unit — bottom-left */}
    <rect x="4" y="26.5" width="10" height="10" rx="1.6" fill={`url(#${gradientId})`} opacity="0.75" />
    {/* D: 1×1 unit — middle, upper */}
    <rect x="14" y="26.5" width="5" height="5" rx="1" fill={`url(#${gradientId})`} opacity="0.7" />
    {/* E: 1×1 unit — middle, lower */}
    <rect x="14" y="31.5" width="5" height="5" rx="1" fill={`url(#${gradientId})`} opacity="0.7" />

    {spiral && (
      <path
        d="M 44 36.5 A 25 25 0 0 1 19 11.5 A 15 15 0 0 1 4 26.5 A 10 10 0 0 1 14 36.5 A 5 5 0 0 1 19 31.5 A 5 5 0 0 1 14 26.5"
        stroke="white"
        strokeOpacity="0.65"
        strokeWidth="1.3"
        strokeLinecap="round"
        fill="none"
      />
    )}
  </svg>
);

export default BonacciStudioIcon;
